module.exports = __webpack_public_path__ + "img/failure-zhant.a19be8c6.png";